// extracted by mini-css-extract-plugin
module.exports = {"container":"_1gcdWXv2","pill":"Fp_68scy","active":"_3Hk6Oazg"};